export default "__VITE_ASSET__DsdASiKq__"